<div class="container-fluid">
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">Setup a Campaign</h5>
    </div>
    <div class="card-body">

      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Campaign Name</label>
          <input type="text" class="form-control" [(ngModel)]="campaignName" placeholder="Diwali Offer 2026" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Message Template (approved only)</label>
          <select class="form-select" [(ngModel)]="selectedTemplateName" (change)="onTemplateChange()">
            <option value="">-- Select a template --</option>
            <option *ngFor="let t of approvedTemplates" [value]="t.name">
              {{ t.name }} ({{ t.language }})
            </option>
          </select>
          <small class="text-muted" *ngIf="loadingTemplates">Loading templates...</small>
          <small class="text-muted" *ngIf="!loadingTemplates && approvedTemplates.length === 0">
            No approved templates yet. Create one and wait for approval.
          </small>
        </div>
      </div>

      <div class="row g-3 mt-1" *ngIf="templateNeedsImage">
        <div class="col-md-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="personalizeImage"
              [(ngModel)]="personalizeImage" (change)="onPersonalizeToggle()" />
            <label class="form-check-label" for="personalizeImage">
              Personalize image with recipient name (prints <strong>"Dear &lt;name&gt;"</strong> in white on the top-left)
            </label>
          </div>
          <small class="text-muted" *ngIf="personalizeImage">
            The name is taken from the first value column (same as {{ '{{' }}1{{ '}}' }}). Upload a base image below.
          </small>
        </div>
        <div class="col-md-6">
          <label class="form-label">
            {{ personalizeImage ? 'Base Image' : 'Header Image' }} <span class="text-danger">*</span>
          </label>
          <input type="file" class="form-control" accept="image/*"
            (change)="onHeaderImageSelected($event)" [disabled]="uploadingHeader" />
          <small class="text-muted d-block mt-1">Max {{ maxImageKb }} KB.</small>
          <small class="text-muted d-block mt-1" *ngIf="uploadingHeader">Uploading...</small>
          <small class="text-success d-block mt-1" *ngIf="(headerImageId || baseImageToken) && !uploadingHeader">
            Uploaded: {{ headerImageName }}
          </small>
          <small class="text-muted d-block mt-1" *ngIf="!(headerImageId || baseImageToken) && !uploadingHeader">
            This template has an image header — an image is required for every message.
          </small>
        </div>
      </div>

      <hr />

      <div class="alert alert-info py-2">
        <strong>Personalising {{ '{{' }}1{{ '}}' }}, {{ '{{' }}2{{ '}}' }} ...</strong>
        In the Excel, put the phone number in one column and the values in the next columns
        (e.g. <em>number | name</em> &rarr; name becomes {{ '{{' }}1{{ '}}' }}). A header row is skipped automatically.
        When pasting, use <em>number, name</em> per line.
      </div>

      <div class="row g-3">
        <div class="col-md-8">
          <label class="form-label">Paste Phone Numbers</label>
          <textarea class="form-control" rows="6" [(ngModel)]="pastedNumbers"
            placeholder="One per line. Optionally add variables after a comma:&#10;919400379939, Jugs&#10;918888888888, Ramesh"></textarea>
          <small class="text-muted">Include country code. First value = number, values after commas = {{ '{{' }}1{{ '}}' }}, {{ '{{' }}2{{ '}}' }} ...</small>
        </div>

        <div class="col-md-4">
          <label class="form-label">Or Upload Excel / CSV</label>
          <input type="file" class="form-control" accept=".xlsx,.xls,.csv"
            (change)="onFileSelected($event)" [disabled]="parsing" />
          <small class="text-muted d-block mt-1" *ngIf="parsing">Parsing file...</small>
          <div class="mt-2" *ngIf="fileRecipients.length > 0">
            <span class="badge bg-info text-dark">{{ fileRecipients.length }} rows from file</span>
            <button class="btn btn-sm btn-link text-danger" (click)="clearFile()">clear</button>
          </div>
        </div>
      </div>

      <!-- Preview -->
      <div class="mt-4" *ngIf="recipientCount > 0">
        <label class="form-label">Preview ({{ recipientCount }} recipients)</label>
        <div class="table-responsive" style="max-height: 260px; overflow: auto;">
          <table class="table table-sm table-bordered align-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>Number</th>
                <th *ngFor="let v of [].constructor(maxVariables); let i = index">{{ '{{' }}{{ i + 1 }}{{ '}}' }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of recipients.slice(0, 50); let idx = index">
                <td>{{ idx + 1 }}</td>
                <td>{{ r.number }}</td>
                <td *ngFor="let v of [].constructor(maxVariables); let i = index">{{ r.variables[i] }}</td>
              </tr>
            </tbody>
          </table>
          <small class="text-muted" *ngIf="recipientCount > 50">Showing first 50 of {{ recipientCount }}.</small>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-4">
        <div>
          <strong>{{ recipientCount }}</strong> unique recipient(s) ready
        </div>
        <button class="btn btn-primary" (click)="send()" [disabled]="sending || recipientCount === 0">
          {{ sending ? 'Starting...' : 'Send Campaign' }}
        </button>
      </div>

    </div>
  </div>
</div>
